import { z } from 'zod';
import { usStateSchema } from '@/enums/us-state';

export const isValidUsState = (value: string) =>
  usStateSchema().safeParse(value).success;

export const optionalUsStateField = (existingValue?: string) =>
  z
    .string()
    .refine(
      (value) =>
        value === existingValue || !value.trim() || isValidUsState(value),
      { message: 'Enter a valid two-letter US state code.' },
    )
    .optional();
